import { FluidGridProps } from '@design-system/fluid-grid';

import { FluidGrid } from './models';

export const fluidGridMapper = ({
  ui: { cardsPerRow, preferredCardSize, variant, tag },
}: FluidGrid): FluidGridProps =>
  ({
    ...(variant === 'fluid' ? { cardsPerRow } : undefined),
    preferredCardSize,
    variant,
    tag,
  } as FluidGridProps);
